import { HUBSPOT_AUTH_TOKEN, HUBSPOT_EXTERNAL_API_URL, HUBSPOT_FINANCING_SERVICE_PROVIDER_FORM_GUID, HUBSPOT_FINANCING_SHIPPER_FORM_GUID, HUBSPOT_PORTAL_ID } from "src/globals";
import { OrgTypes } from "src/Library/Constants";
import apiProvider from "../provider";
import { getErrorMessage } from "../utils";

export const postFinancingRequiredFormData = async (payload: any, type: OrgTypes) => {
    try {
        const url = `${HUBSPOT_EXTERNAL_API_URL}/${HUBSPOT_PORTAL_ID}/${type === OrgTypes.SHIPPER ? HUBSPOT_FINANCING_SHIPPER_FORM_GUID : HUBSPOT_FINANCING_SERVICE_PROVIDER_FORM_GUID}`
        const response = await apiProvider.post(url, payload,
          {
            headers: Object.assign(getHubspotAuthHeaders()),
          },
        );
        return {
          isSuccess: true,
        };
      } catch (err) {
        const errorMessage = getErrorMessage(err);
        return {
          errorMessage,
          isSuccess: false,
        };
      }
}

const getHubspotAuthHeaders = () => {
    return {
        'Authorization': HUBSPOT_AUTH_TOKEN,
        'content-type': 'application/json'
    };
}
